import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../../redux/messages";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";

//redux
import {
  deleteTrainings,
  editTrainings,
  getTrainings,
  saveTrainings,
} from "../../../redux/capacitacionDesarrollo/trainings/actions";

const Trainings = (props) => {
  const schema = Yup.object().shape({
    descripcion_capacitacion: Yup.string()
      .ensure()
      .required("**Campo requerido"),
    nombre_capacitacion: Yup.string().ensure().required("**Campo requerido"),
    codigo_capacitacion: Yup.string().ensure().required("**Campo requerido"),
  });

  const {
    loaderTrainings,
    trainings,
    trainingsFail,
    saveLoaderTrainings,
    trainingsFormError,
  } = useSelector((store) => store.trainings);

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_capacitacion",
    desc: "Competencia",
  });
  const filters = [
    { id: "descripcion_capacitacion", desc: "Descripción" },
    { id: "nombre_capacitacion", desc: "Nombre" },
    { id: "codigo_capacitacion", desc: "Código" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const pages = Math.ceil(trainings ? trainings.count / limit : 0);

  //Datos custom table
  const columns = [
    {
      Header: "Código",
      accessor: "codigo_capacitacion",
    },
    {
      Header: "Competencias",
      accessor: "nombre_capacitacion",
    },
    {
      Header: "Descripción",
      accessor: "descripcion_capacitacion",
    },

    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  //methods
  const _getTrainings = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getTrainings({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteTrainings(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTrainings(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTrainings(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    //  const exist = trainings.data.find((e) => e.nombre_capacitacion === req.nombre_capacitacion);
    const codExist = trainings.data.find(
      (e) => e.codigo_capacitacion === req.codigo_capacitacion
    );
    //  if (codExist) {
    //    toastr.info("El código ya existe.");
    //    return;
    //   }
    if (!edit) {
      if (codExist) {
        toastr.info("El código ya existe.");
        return;
      }
      dispatch(saveTrainings(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editTrainings(req, index, setShowFormModal));
    }
  };

  useEffect(() => {
    _getTrainings();
  }, []);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCapacitacion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              COMPETENCIAS A DESARROLLAR
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!trainingsFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-1">
              {trainingsFail}
            </Alert>
          )}
          {loaderTrainings ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : trainings != null && trainings.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={trainings.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={trainings.count}
                pages={pages}
                pagFunc={_getTrainings}
              />
            </>
          ) : (
            <Alert variant="info" className="mt-4 mb-1 mx-1">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              descripcion_capacitacion: edit
                ? editItem.descripcion_capacitacion
                : "",
              nombre_capacitacion: edit ? editItem.nombre_capacitacion : "",
              codigo_capacitacion: edit ? editItem.codigo_capacitacion : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Competencia" : "Crear Competencia"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {trainingsFormError &&
                  typeof trainingsFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {trainingsFormError}
                    </Alert>
                  ) : null}

                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Código
                    </Form.Label>
                    <Form.Control
                      name="codigo_capacitacion"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.codigo_capacitacion}
                      placeholder="código"
                      onBlur={handleBlur("codigo_capacitacion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.codigo_capacitacion &&
                        !!errors.codigo_capacitacion
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.codigo_capacitacion}
                    </Form.Control.Feedback>
                    {trainingsFormError &&
                    typeof trainingsFormError === "object" &&
                    trainingsFormError.codigo_capacitacion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {trainingsFormError.codigo_capacitacion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre competencia
                    </Form.Label>
                    <Form.Control
                      name="nombre_capacitacion"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre_capacitacion}
                      placeholder="Nombre"
                      onBlur={handleBlur("nombre_capacitacion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.nombre_capacitacion &&
                        !!errors.nombre_capacitacion
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_capacitacion}
                    </Form.Control.Feedback>
                    {trainingsFormError &&
                    typeof trainingsFormError === "object" &&
                    trainingsFormError.nombre_capacitacion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {trainingsFormError.nombre_capacitacion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Descripción competencia
                    </Form.Label>
                    <Form.Control
                      name="descripcion_capacitacion"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.descripcion_capacitacion}
                      placeholder="Descripción"
                      onBlur={handleBlur("descripcion_capacitacion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.descripcion_capacitacion &&
                        !!errors.descripcion_capacitacion
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion_capacitacion}
                    </Form.Control.Feedback>
                    {trainingsFormError &&
                    typeof trainingsFormError === "object" &&
                    trainingsFormError.descripcion_capacitacion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {trainingsFormError.descripcion_capacitacion.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderTrainings}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderTrainings && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default Trainings;
